var lib_core  = require("lib-core");
var Editor2DController = require("../editor2D/editor2DController.js");
var MovingController = require("../moving/movingController.js");
var SelectionController = require("../selection/selectionController.js");

var CopyPasteStateMachine = require("./copyPasteStateMachine.js");

var CopyPasteController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
    this.configuration = configuration;
};
lib_core.inherit(CopyPasteController, lib_core.Controller);
CopyPasteController.inject = {
    appController: lib_core.AppController,
    editor2DController : Editor2DController,
    movingController : MovingController,
    selectionController : SelectionController
};

module.exports = CopyPasteController;

CopyPasteController.prototype.createStateMachine = function () {
    var editorModel = this.editor2DController.getModel();
    var movingModel = this.movingController.getModel();
    var selectionModel = this.selectionController.getModel();
    var assetType = this.appController.configuration.dataManagerConfig.document_options.assetType;  // TODO: is this the best way to determine the type of resource in which you are copy pasting?

    return new CopyPasteStateMachine(this.root, assetType, editorModel, movingModel, selectionModel, this.configuration.crossEditorPaste);
};
